import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { MatDialog } from '@angular/material/dialog'

import { Subscription } from 'rxjs'
import { filter, map, tap } from 'rxjs/operators'
import { TouaregControlSearchDialogComponent } from '../touareg-control-search-dialog/touareg-control-search-dialog.component'
import { Samv2Module } from '@aubert-et-duval/samv2';

@Component({
  selector: 'app-touareg-control-search',
  templateUrl: './touareg-control-search.component.html',
  styleUrls: ['./touareg-control-search.component.scss'],
  imports: [Samv2Module],
})
export class TouaregControlSearchComponent implements OnInit, OnDestroy {
  @Output()
  select = new EventEmitter<any>()

  private _touaregStatesSubs$!: Subscription
  constructor(private _dialog: MatDialog) {}

  ngOnInit(): void {
    // this._touaregStatesSubs$ = this._network.networkChange$.subscribe(
    //   ({ network }) => {
    //     this.isOnline = network
    //     if (network) document.body.classList.remove('is-offline')
    //     else document.body.classList.add('is-offline')
    //   }
    // )
  }

  public onSearchOpen(e: MouseEvent) {
    const dialogRef = this._dialog.open(TouaregControlSearchDialogComponent, {
      width: '480px',
      // maxWidth: '480px',
      height: '80vh',
      // maxHeight: '700px',
      autoFocus: 'first-header' as any,
    })
    dialogRef
      .afterClosed()
      .pipe(
        filter((a) => a),
        map((a) => a.map((b: { value: any }) => b.value))
      )
      .subscribe((data) => {
        this.select.emit(data)
      })
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (!!this._touaregStatesSubs$) this._touaregStatesSubs$.unsubscribe()
  }
}
